import { UNDO_REDUCER_KEY } from './undoReducer';

const getStore = (state) => state[UNDO_REDUCER_KEY];
export const getUndoStack = (state) => getStore(state).undoStack;
